'use client'

import { Children } from 'react'
import { createGlobalStyle } from 'styled-components'

import { color, typography } from '../../themes'

// https://gist.github.com/ryanmcgrath/982242
const JAPANESE =
  '\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u2605-\u2606\u2190-\u2195\u203B'
const regex = new RegExp(
  `(https?://[a-zA-Z0-9-_.:@!~*'(¥);/?&=+$,%#${JAPANESE}]+)`,
  'g',
)

const GlobalAutoLinkStyles = createGlobalStyle`
  .auto-link {
    ${typography('body1')};
    color: ${color('gray.02')};
    transition: opacity 0.15s ease;
    text-decoration: underline;
    text-underline-position: under;

    &:hover {
      opacity: 0.5;
    }
  }
`

export interface AutoLinkProps {
  children: React.ReactNode
}

export const AutoLink = ({ children }: AutoLinkProps) => {
  const childArr = Children.toArray(children)

  return (
    <>
      {childArr.map((child, i) => {
        if (typeof child === 'string') {
          return (
            <span
              key={i}
              dangerouslySetInnerHTML={{
                __html: child.replace(
                  regex,
                  '<a href="$1" class="auto-link" target="_blank" rel="nofollow">$1</a>',
                ),
              }}
            />
          )
        }

        return child
      })}
    </>
  )
}

AutoLink.GlobalStyles = GlobalAutoLinkStyles
